import { List } from "antd";
import _ from "lodash";
import { useQuery, useQueryClient } from "react-query";
import { getOMProductInfo } from "../../../../../apis/OrderManagement/order";
import { CustomerOrderProductInfo } from "../../../../../model/OrderManagement/CustomerOrder";
import { ListStyled, Section } from "../index.styled";
import { RepairProductItemTireCardForm } from "./Tire";

interface RepairProductInfoFormProps {
  repairNo?: string;
}

/**
 * 매장주문 > 출고정보
 * @TODO 외부채널 기본차량정보..
 * @param param0
 * @returns
 */
export const RepairProductInfoForm: React.FC<RepairProductInfoFormProps> = ({
  repairNo,
}) => {
  const queryClient = useQueryClient();
  /**
   * 상품정보
   */
  const { data, isLoading, isFetching } = useQuery(
    ["OM", repairNo, "OrderProductInfo"],
    () => getOMProductInfo(repairNo as string),
    {
      enabled:
        !!repairNo &&
        !queryClient.getQueryData(["OM", repairNo, "OrderProductInfo"]),
      refetchOnMount: "always",
    }
  );

  return (
    <Section style={{ padding: 0, height: "100%", position: "relative" }}>
      <ListStyled
        loading={isLoading || isFetching}
        dataSource={
          data
            ? _.sortBy(
                data?.rows,
                (item: CustomerOrderProductInfo) => item.orderItemName
              )
            : undefined
        }
        split={false}
        renderItem={(item: any) => (
          <List.Item key={item.orderItemNo}>
            <RepairProductItemTireCardForm dataSource={item} />
          </List.Item>
        )}
      />
    </Section>
  );
};
